module.exports = __webpack_public_path__ + "img/zdykc.9e2b9f39.png";